import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../../services/AuthService";
import { resetAuthData } from "../../app/providers/authSlice";

const logoutRequest = async (token) => {
    await AuthService.logout(token).then((response) => {
        //Suppression des données utilisateurs   
        
    }).catch(error => {
        console.log(error.message)
    });
}

export default function Logout(params) {
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth)

};

export {logoutRequest} ;

